import type {
  GoogleAnalyticsEventParameterType,
  GoogleAnalyticsEventValue
} from '@elfsight/lib-google-analytics';
import { snakeCase } from 'es-toolkit';
import { sendEvent } from './sendEvent';

export type ValueMapping<T extends string> = Record<T, string>;

type SendGoogleAnalyticsEventsArgs<
  T extends string = string,
  V extends string = string
> = {
  googleAnalyticsEvents: GoogleAnalyticsEventValue<T, V>[];
  eventType: T;
  editMode?: boolean;
  valueMapping?: Partial<ValueMapping<V | GoogleAnalyticsEventParameterType>>;
};

export function sendGoogleAnalyticsEvents<
  T extends string = string,
  V extends string | GoogleAnalyticsEventParameterType = string
>({
  googleAnalyticsEvents,
  eventType,
  editMode,
  valueMapping
}: SendGoogleAnalyticsEventsArgs<T, V>) {
  if (!googleAnalyticsEvents.length || editMode) {
    return;
  }

  googleAnalyticsEvents
    .filter(({ type }) => type === eventType)
    .forEach(({ name, parameters }) => {
      const processedParams: Record<string, string> = {};

      parameters.forEach(({ type, name: paramName, value }) => {
        const key = snakeCase(paramName || type);
        processedParams[key] = valueMapping?.[type] ?? value ?? '';
      });

      sendEvent({
        name,
        parameters: processedParams
      });
    });
}
